import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { makeStyles } from '@material-ui/styles';

import { srcOrNextImageProp } from 'PropTypes/imageProps';
import useMedia from 'utils/useMedia';

import BlockLayout from 'Blocks/BlockLayout';
import { breakpoints } from 'Components/ThemeProvider';
import Typography from 'Components/Typography';

const ImageContainer = styled.div`
  width: 100%;
  height: 30vw;

  background-position: center top;
  background-repeat: no-repeat;
  background-size: contain;

  ${props => props.theme.breakpoints.match('md')} {
    height: 50vh;

    background-position: center;
    background-size: cover;
  }

  ${props => props.theme.breakpoints.match('sm')} {
    height: 80vh;

    background-position: center;
    background-size: cover;
  }
`;

const useStyles = makeStyles(
  () => ({
    root: {
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',

      '& h2': {
        marginBottom: 12,
      },
    },
    content: {
      marginTop: 100,
      marginBottom: 100,
    },
  }),
  { name: 'UgcBlock' }
);

const UgcBlock = ({ content }) => {
  const isTablet = useMedia(`(max-width: ${breakpoints.md - 1}px)`);
  const isMobile = useMedia(`(max-width: ${breakpoints.sm - 1}px)`);
  const classes = useStyles();

  return (
    <BlockLayout
      backgroundColor="#F7F0EB"
      classes={{ root: classes.root, content: classes.content }}
      contentAlign="center"
      contentWidth="veryWide"
    >
      <Typography color="noir" markupName="h2" variant="mono1">
        {content.title}
      </Typography>

      <Typography color="noir" markupName="p" variant="h1">
        <a
          data-click="ig"
          data-from="block-ugc"
          href="https://www.instagram.com/explore/tags/prosehair/"
          rel="noopener noreferrer"
          target="_blank"
        >
          {content.secondaryTitle}
        </a>
      </Typography>

      <ImageContainer
        style={{
          backgroundImage: `url(${
            isMobile ? content.imageM : isTablet ? content.imageT : content.image
          })`,
        }}
      />
    </BlockLayout>
  );
};

UgcBlock.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    secondaryTitle: PropTypes.string.isRequired,
    image: srcOrNextImageProp.isRequired,
    imageM: srcOrNextImageProp.isRequired,
    imageT: srcOrNextImageProp.isRequired,
  }).isRequired,
};

export default UgcBlock;
